import { render, staticRenderFns } from "./p23.vue?vue&type=template&id=c8aa912a&scoped=true&"
import script from "./p23.vue?vue&type=script&lang=js&"
export * from "./p23.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8aa912a",
  null
  
)

export default component.exports